/* eslint-disable no-shadow */
/* eslint-disable react/no-unused-state */
import React from "react";
import { ButtonToolbar } from "react-bootstrap";
import moment from "moment";
import { connect } from "react-redux";
import { PageWrapper } from "../../../shared/layout";
import { Tabs, BarLoader, RangePicker } from "../../../shared/widgets";
import PreviousSettlements from "../settlement/operatorSettlement/PreviousSettlements";
import PendingSettlement from "./PendingSettlement";
import { selectDateFilter } from "../../../redux/actions/dateFilterAction";
import "./operatorSettlementTab.css";

class OperatorSettlementTab extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      value: "pending",
      pageNo: 0,
      rowsPerPage: 10,
      count: 100,
      totalPages: 0,
    };
    this.handleTabChange = this.handleTabChange.bind(this);
  }

  componentDidMount() {
    window.dispatchEvent(new CustomEvent("navigationhandler"));
  }

  handleDatesChange = (dates) => {
    const { selectDateFilter: selectDateFilterProp } = this.props;
    if (dates.startDate && dates.endDate) {
      const fromDate = parseFloat(new Date(dates.startDate).getTime());
      const toDate = parseFloat(new Date(dates.endDate).getTime());
      selectDateFilterProp({ fromDate, toDate });
    }
  };

  handleTabChange(value) {
    this.setState({ value, page: 0, selected: [] });
  }

  render() {
    const { value } = this.state;
    const { selectedDateFilter } = this.props;
    return (
      <div className="pageContainer">
        <PageWrapper>
          <PageWrapper.Header hideS>
            <div className="flex row-reverse-flex flex-ratio">
              {value === "pending" && (
                <ButtonToolbar>
                  <RangePicker
                    startDate={moment(new Date(selectedDateFilter.fromDate))}
                    endDate={moment(new Date(selectedDateFilter.toDate))}
                    monthsToDisplay={1}
                    onDatesChange={this.handleDatesChange}
                  />
                </ButtonToolbar>
              )}
              <div className="dataTables_length tabWrapper display-block scroll-horiz">
                <Tabs
                  activeTab={value}
                  tabs={[
                    { key: "pending", display: "Pending" },
                    { key: "previousSettlements", display: "Completed" },
                  ]}
                  onTabSelection={(key) => {
                    this.handleTabChange(key);
                  }}
                />
              </div>
            </div>
          </PageWrapper.Header>
          {value === "pending" ? (
            <PendingSettlement />
          ) : (
            <div>
              <BarLoader scope="header" />
              <PreviousSettlements />
            </div>
          )}
        </PageWrapper>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    selectedDateFilter: state.DateFilter.selectedDateFilter,
  };
}

const mapDispatchToProps = (dispatch) => ({
  selectDateFilter: (value) => {
    dispatch(selectDateFilter(value));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(OperatorSettlementTab);
